import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemConfigStore } from "@app/services/store/system-config-store";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { SystemConfig } from "@app/models/rest/system-config";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-system-config-list",
  templateUrl: "./system-config-list.component.html",
  styleUrls: ["./system-config-list.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class SystemConfigListComponent
  extends BaseDataTablePageDirective<SystemConfig>
  implements OnInit
{
  systemConfigStore: SystemConfigStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;
  private activeRoute = inject(ActivatedRoute);

  @Input()
  public columns: object[] = [
    {
      field: "configName",
      text: "Name",
      flex: 1,
      editor: true
    },
    {
      field: "configValue",
      text: "Value",
      flex: 3,
      editor: true
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const systemConfigStore = inject(SystemConfigStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      systemConfigStore,
      store,
      dialog,
      "SystemConfig",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.systemConfigStore = systemConfigStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.add([
      {
        configName: "",
        configValue: ""
      }
    ]);
  }
}
